import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from '@tanstack/react-router'

import appCss from '../styles.css?url'

import type { QueryClient } from '@tanstack/react-query'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  // Client-only SPA: the worker serves the shell, the browser calls /p/*.
  ssr: false,
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: 'Paperwork Playground' },
      {
        name: 'description',
        content: 'Run the CloudRaker paperwork API on a sample or your own file. No signup.',
      },
      { name: 'color-scheme', content: 'light dark' },
    ],
    links: [
      { rel: 'stylesheet', href: appCss },
      { rel: 'preconnect', href: 'https://use.typekit.net', crossOrigin: 'anonymous' },
      { rel: 'icon', href: '/favicon.svg', type: 'image/svg+xml' },
    ],
  }),
  component: () => <Outlet />,
  shellComponent: ({ children }) => (
    <html lang="en">
      <head>
        <HeadContent />
        {/* Typekit off the critical path: load as print, swap in once it arrives. */}
        <link
          rel="stylesheet"
          href="https://use.typekit.net/jsi6sjs.css"
          media="print"
          onLoad={(e) => {
            e.currentTarget.media = 'all'
          }}
        />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  ),
})
